export const maskCardNumber = (cardNumber: string): string => {
  if (!cardNumber) return '';

  // Extract just the digits from the card number (in case it has spaces/symbols)
  const digits = cardNumber.replaceAll(/\D/g, '');

  // If there are fewer than 4 digits, return as-is
  if (digits.length <= 4) return digits;

  // Return format: *********1234 (9 asterisks + last 4 digits, no pattern spacing)
  const masked = '*'.repeat(digits.length - 4) + digits.slice(-4);
  return masked;
};
